import ChevronRight from '@ixigo/icons/ChevronRight';
import Typography from '@ixigo/iui/Typography';
import type { CabUpdateResponse } from '@/api';
import { WaitingTimeChip } from '@/components/cab-update';
import type { TransformedBookingInfo } from './utils';

interface StatusProps {
	bookingDetail: TransformedBookingInfo['bookingDetail'];
	cabUpdate: CabUpdateResponse | null;
	isTripActive: boolean;
}

const OTP_SHOW_STATUS = ['CAB_ARRIVED', 'TRIP_STARTED'];

export const Status = ({
	bookingDetail,
	cabUpdate,
	isTripActive,
}: StatusProps) => {
	const { commuteMsg } = bookingDetail || {};

	const { msg, waitingInfo, pin, rideStatus = '' } = cabUpdate || {};
	const communicationMsg = msg || commuteMsg;

	return (
		<div className="flex items-center justify-between gap-x-5 w-full">
			{pin &&
			!waitingInfo?.showTimer &&
			OTP_SHOW_STATUS.includes(rideStatus) ? (
				<div className="flex items-center gap-x-5 w-full justify-between">
					<Typography variant="body-xs" className="text-secondary">
						Ride OTP:
					</Typography>
					<div className="flex gap-0.5 items-center justify-start relative font-medium text-info-solid">
						{pin.value.split('').map((digit, index) => (
							<Typography
								key={index}
								variant="body-xs"
								className="bg-info-solid px-1 rounded-sm w-15"
							>
								{digit}
							</Typography>
						))}
					</div>
				</div>
			) : (
				<div className="flex items-center justify-between gap-x-5 truncate">
					<Typography
						variant="body-xs"
						className="text-secondary truncate"
						// biome-ignore lint/security/noDangerouslySetInnerHtml: <just a static msg to show current cab status>
						dangerouslySetInnerHTML={{ __html: communicationMsg }}
					/>
					{waitingInfo?.showTimer && (
						<WaitingTimeChip waitingInfo={waitingInfo} variant="soft" />
					)}
				</div>
			)}
			{isTripActive && <ChevronRight />}
		</div>
	);
};
